import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LoaderContainer = styled.div<{ $size: string }>`
  width: ${({ $size }) => $size};
  position: fixed;
  bottom: ${spacing('xxl')};
  left: 50%;
`;
